var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header",
    transform: "translate(-660.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(564.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(96.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "BG",
    fillOpacity: 0,
    fill: "#D8D8D8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: ".misc-/-Fill-/-Grey-5",
    mask: "url(#mask-2)",
    fill: "#F4F6FC"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.871345,16.2 C11.2556835,16.2 11.5672515,15.8865993 11.5672515,15.5 L11.5672515,11.3 C11.5672515,10.9134007 11.2556835,10.6 10.871345,10.6 C10.4870065,10.6 10.1754386,10.9134007 10.1754386,11.3 L10.1754386,15.5 C10.1754386,15.8865993 10.4870065,16.2 10.871345,16.2 Z M17.8304094,7.8 L15.0467836,7.8 L15.0467836,7.1 C15.0467836,5.94020203 14.1120799,5 12.9590643,5 L11.5672515,5 C10.4142359,5 9.47953216,5.94020203 9.47953216,7.1 L9.47953216,7.8 L6.69590643,7.8 C6.31156792,7.8 6,8.11340068 6,8.5 C6,8.88659932 6.31156792,9.2 6.69590643,9.2 L7.39181287,9.2 L7.39181287,16.9 C7.39181287,18.059798 8.32651663,19 9.47953216,19 L15.0467836,19 C16.1997992,19 17.1345029,18.059798 17.1345029,16.9 L17.1345029,9.2 L17.8304094,9.2 C18.2147479,9.2 18.5263158,8.88659932 18.5263158,8.5 C18.5263158,8.11340068 18.2147479,7.8 17.8304094,7.8 Z M10.871345,7.1 C10.871345,6.71340068 11.182913,6.4 11.5672515,6.4 L12.9590643,6.4 C13.3434028,6.4 13.6549708,6.71340068 13.6549708,7.1 L13.6549708,7.8 L10.871345,7.8 L10.871345,7.1 Z M15.7426901,16.9 C15.7426901,17.2865993 15.4311221,17.6 15.0467836,17.6 L9.47953216,17.6 C9.09519365,17.6 8.78362573,17.2865993 8.78362573,16.9 L8.78362573,9.2 L15.7426901,9.2 L15.7426901,16.9 Z M13.6549708,16.2 C14.0393093,16.2 14.3508772,15.8865993 14.3508772,15.5 L14.3508772,11.3 C14.3508772,10.9134007 14.0393093,10.6 13.6549708,10.6 C13.2706323,10.6 12.9590643,10.9134007 12.9590643,11.3 L12.9590643,15.5 C12.9590643,15.8865993 13.2706323,16.2 13.6549708,16.2 Z",
    id: "Shape",
    fill: "#7450C8",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.146b1158374958a4f735329ea72e1255.svg";
export { ForwardRef as ReactComponent };